import { createAction, props } from '@ngrx/store';
import { billModel, invalidaBills } from './paymentlinks.model';

// fetch  bills
export const getPaymentLink = createAction(
  '[getPaymentLink] getPaymentLink',
  props<{
    pageIndex: number;
    pageSize: number;
    searchTerm: string;
    projectId: string;
    filter?: string;
    orderBy?: string;
  }>()
);
export const getPaymentLinkSuccess = createAction(
  '[paymentlink] success',
  props<{ getpaymentLinkResponse: any }>()
);
export const getPaymentLinkFailure = createAction(
  '[paymentlink fetch failed]',
  props<{ getpaymentlinkError: any }>()
);

// fetch  bills Export
export const getAllPaymentlinksListExport = createAction(
  '[getAllPaymentlinksListExport ]  Export',
  props<{
    pageIndex: number;
    pageSize: number | undefined;
    searchTerm: string;
    projectId: string;
    filter?: string;
    orderBy?: string;
    criteria?: string,
  }>()
);
export const getAllPaymentLinkSuccess = createAction(
  '[getAllPaymentlinksListExport]  Export success',
  props<{ getallpaymentlinkExportResponse: any }>()
);
export const getAllPaymentLinkFailure = createAction(
  '[getAllPaymentlinksListExport fetch  Export failed]',
  props<{ getallpaymentlinkExportError: any }>()
);


export const resetPaymentlinksDetailsState = createAction('[resetPaymentlinksDetailsState ] resetState');
